<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--차량정보-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001353') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- 제품 ID-->
							<th class="col-1">* {{ getMessage_('QWCC001538') }}</th>
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input
												v-model="pmcId"
												class="inputWithIcon"
												maxlength="20"
												@keyup.native.delete="onPmcIdInuPutKeyDown()"
												@change="onPmcIdInuPutKeyDown"
												:readonly="pwaApcnPopUp.readOnlyAuth"
											></el-input>
											<i class="icon-sf-search search-icon" @click="() => onPmcPopup()"></i>
										</div>
									</el-col>
								</div>
							</td>
							<th class="col-1">Vin No.</th>
							<td class="col-1"><el-input v-model="carVin" readonly /></td>
							<!--연료전지사양-->
							<!-- <th class="col-1">{{ getMessage_('QWCC001021') }}</th>
							<td class="col-1"><el-input v-model="flclSpcNm" readonly /></td> -->
							<!--차량유형-->
							<th class="col-1">{{ getMessage_('QWCC001016') }}</th>
							<td class="col-1"><el-input v-model="carTypeNm" readonly /></td>

							<!--HTWO판매일-->
							<th class="col-1">{{ getMessage_('QWCC001044') }}</th>
							<td class="col-1">
								<el-input v-model="erpSaleDd" readonly />
							</td>
							<!--고객사 판매일-->
							<th class="col-1">{{ getMessage_('QWCC001047') }}</th>
							<td class="col-1">
								<el-input v-model="oemSaleDd" readonly />
							</td>
						</tr>
						<tr>
							<!--판매사-->
							<!-- <th class="col-1">{{ getMessage_('QWCC001045') }}</th>
							<td class="col-1"><el-input v-model="custNm" readonly /></td> -->
							<!--판매지역-->
							<th class="col-1">{{ getMessage_('QWCC001019') }}</th>
							<td class="col-1">
								<el-input v-model="saleRegnNm" readonly />
							</td>
							<!-- 质保起始日-->
							<th class="col-1">{{ getMessage_('QWCC002102') }}</th>
							<td class="col-1">
								<el-input v-model="wrntStrtDd" readonly />
							</td>
							<!--보증기간(년)-->
							<th class="col-1">{{ getMessage_('QWCC001351') }}</th>
							<td class="col-1">
								<el-input v-model="usePrdPo" readonly />
							</td>
							<!--보증사용거리(만Km)-->
							<th class="col-1">{{ getMessage_('QWCC001023') }}</th>
							<td class="col-1"><el-input v-model="milgPo" readonly /></td>
							<!--보증만료일-->
							<th class="col-1">{{ getMessage_('QWCC002009') }}</th>
							<td class="col-1">
								<el-input v-model="wrntEndDd" readonly />
							</td>
						</tr>
						<tr>
							<!--차량번호판-->
							<th class="col-1">{{ getMessage_('QWCC002119') }}</th>
							<td class="col-1"><el-input v-model="licensePlate" readonly /></td>
							<!--최종고객명-->
							<th class="col-1">{{ getMessage_('QWCC001013') }}</th>
							<td class="col-1"><el-input v-model="custNm" readonly /></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
import moment from 'moment';
export default {
	props: {
		scrId: { type: String, default: '' },
		sendParam5: { type: Object }
	},
	components: {},
	data() {
		return {
			carVin: '', // 차대번호
			pmcNo: '', //PMC번호
			pmcId: '', //PMCId
			vehlNm: '', //차종명
			vehlCd: '', //차종코드
			carTypeNm: '', //차종유형

			erpSaleDd: '', //HTWO판매일
			custNm: '', //판매사
			saleRegnNm: '', //판매지역
			flclSpcNm: '', //연료전지사양
			usePrdPo: '', //보증사용기간
			milgPo: '', //보증주행거리
			oemSaleDd: '', //고객사판매일
			pmcNoInput: '',

			wrntStrtDd: '', //품질보증 시작일
			wrntEndDd: '', //보증만료일
			licensePlate: '' //차량번호판
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		chgFlag() {
			return this.getIsSaveFlag_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onPmcPopup() {
			//console.log('값은>>>>>>>>', this.pmcNoInput);

			//console.log('리드온리여부', this.pwaApcnPopUp.readOnlyAuth);

			if (this.pwaApcnPopUp.readOnlyAuth == false) {
				this.pmcNoInput = this.pmcId;

				/*현상팝업*/
				this.$emit('OpenPmcPopup', this.pmcNoInput);
			}
		},
		onPmcIdInuPutKeyDown() {
			// 지웠을때 실행함
			if (this.pwaApcnPopUp.readOnlyAuth == false) {
				this.carVin = '';
				this.pmcNo = '';
				this.pmcId = '';
				this.vehlNm = '';
				this.vehlCd = '';
				this.custNm = '';
				this.carTypeNm = '';
				this.saleRegnNm = '';
				this.erpSaleDd = '';
				this.milgPo = '';
				this.usePrdPo = '';
				this.flclSpcNm = '';
				this.oemSaleDd = '';
				this.wrntStrtDd = '';
				this.wrntEndDd = '';
				this.licensePlate = '';
			}
		},
		setProcessInfo() {
			this.carVin = this.pwaApcnPopUp.carVin; // Vin No
			this.pmcNo = this.pwaApcnPopUp.pmcNo; //pmc 번호
			this.pmcId = this.pwaApcnPopUp.pmcId; //pmc 아이디
			//this.vehlNm = this.pwaApcnPopUp.vehlNm; //차종명
			this.vehlNm = this.pwaApcnPopUp.vehlCd; //차종명
			this.vehlCd = this.pwaApcnPopUp.vehlCd; //차종코드
			this.carTypeNm = this.pwaApcnPopUp.carTypeNm; //차종유형

			this.custNm = this.pwaApcnPopUp.custNm; //판매사
			this.saleRegnNm = this.pwaApcnPopUp.saleRegnNm; //판매지역

			this.erpSaleDd = this.pwaApcnPopUp.erpSaleDd; //HTWO판매일

			this.wrntStrtDd = this.pwaApcnPopUp.wrntStrtDd; //품질보증 시작일

			this.milgPo = this.pwaApcnPopUp.milgPo; //보증주행거리
			this.usePrdPo = this.pwaApcnPopUp.usePrdPo; //보증사용기간

			this.wrntEndDd = this.pwaApcnPopUp.wrntEndDd; //보증만료일

			this.flclSpcNm = this.pwaApcnPopUp.flclSpcNm; //연료전지사양
			this.oemSaleDd = this.pwaApcnPopUp.oemSaleDd; //고객판매일
			this.licensePlate = this.pwaApcnPopUp.licensePlate; //차량번호판
		},
		chkPmcId() {}
	},
	async created() {
		//스토어에서 값을 가져와서 셋팅한다.
		if(this.pwaApcnPopUp.oemSaleDd!=null){
			this.carVin = this.pwaApcnPopUp.carVin; // Vin No
			this.pmcNo = this.pwaApcnPopUp.pmcNo; //pmc 번호
			//this.vehlNm = this.pwaApcnPopUp.vehlNm; //차종명
			this.vehlNm = this.pwaApcnPopUp.vehlCd; //차종명
			this.vehlCd = this.pwaApcnPopUp.vehlCd; //차종코드
			this.carTypeNm = this.pwaApcnPopUp.carTypeNm; //차종유형

			this.custNm = this.pwaApcnPopUp.custNm; //판매사
			this.saleRegnNm = this.pwaApcnPopUp.saleRegnNm; //판매지역
			this.oemSaleDd = this.pwaApcnPopUp.oemSaleDd; //고객판매일

			this.wrntStrtDd = this.pwaApcnPopUp.wrntStrtDd; //품질보증 시작일
			this.wrntEndDd = this.pwaApcnPopUp.wrntEndDd; //보증만료일

			this.milgPo = this.pwaApcnPopUp.milgPo; //보증주행거리
			this.usePrdPo = this.pwaApcnPopUp.usePrdPo; //보증사용기간
			this.licensePlate = this.pwaApcnPopUp.licensePlate; //차량번호판
		}else{
			this.carVin = ""; // Vin No
			this.pmcNo = ""; //pmc 번호

			this.carTypeNm = ""; //차종유형

			this.custNm = ""; //판매사
			this.saleRegnNm = ""; //판매지역

			this.oemSaleDd = ""; //고객판매일

			this.milgPo = ""; //보증주행거리
			this.usePrdPo = ""; //보증사용기간

			this.wrntStrtDd = '';//품질보증 시작일
			this.wrntEndDd = '';//보증만료일
			this.licensePlate = ''; //차량번호판
		}
		this.pmcId = this.pwaApcnPopUp.pmcId; //pmc Id
		this.flclSpcNm = this.pwaApcnPopUp.flclSpcNm; //연료전지사양
		this.erpSaleDd = this.pwaApcnPopUp.erpSaleDd; //HTWO판매일
		this.setStatePwaApcnState_({ key: 'erpSaleDd', value: this.pwaApcnPopUp.erpSaleDd });
		this.setStatePwaApcnState_({ key: 'oemSaleDd', value: this.pwaApcnPopUp.oemSaleDd }); //조건

	},
	watch: {
		sendParam5(newValue, oldValue) {
			if(this.sendParam5.oemSaleDd!=null){
				this.carVin = this.sendParam5.carVin; // Vin No
				this.pmcNo = this.sendParam5.pmcNo; //pmc 번호

				this.carTypeNm = this.sendParam5.carTypeNm; //차종유형

				this.custNm = this.sendParam5.custNm; //판매사
				this.saleRegnNm = this.sendParam5.saleRegnNm; //판매지역

				this.oemSaleDd = this.sendParam5.oemSaleDd; //고객판매일

				this.milgPo = this.sendParam5.milg; //보증주행거리
				this.usePrdPo = this.sendParam5.usePrd; //보증사용기간

				this.wrntStrtDd = this.sendParam5.wrntStrtDd; //품질보증 시작일
				this.wrntEndDd = this.sendParam5.wrntEndDd; //보증만료일
				this.licensePlate = this.sendParam5.licensePlate; //차량번호판
			}else{
				this.carVin = ""; // Vin No
				this.pmcNo = ""; //pmc 번호

				this.carTypeNm = ""; //차종유형

				this.custNm = ""; //판매사
				this.saleRegnNm = ""; //판매지역

				this.oemSaleDd = ""; //고객판매일

				this.milgPo = ""; //보증주행거리
				this.usePrdPo = ""; //보증사용기간

				this.wrntStrtDd = '';//품질보증 시작일
				this.wrntEndDd = '';//보증만료일
				this.licensePlate = ''; //차량번호판
			}
			this.pmcId = this.sendParam5.pmcId; //pmc Id
			this.flclSpcNm = this.sendParam5.flclSpcNm; //연료전지사양
			this.erpSaleDd = this.sendParam5.erpSaleDd; //HTWO판매일

			this.setStatePwaApcnState_({ key: 'erpSaleDd', value: this.sendParam5.erpSaleDd });
			this.setStatePwaApcnState_({ key: 'oemSaleDd', value: this.sendParam5.oemSaleDd }); //조건
		},
		chgFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.getIsSaveFlag_) {
				this.setStateApcnSave_({ key: 'pmcNo', value: convertNvl(this.pmcNo, '') }); //PMC번호
				this.setStateApcnSave_({ key: 'pmcId', value: convertNvl(this.pmcId, '') }); //PMCId
				this.setStateApcnSave_({ key: 'vehlCd', value: convertNvl(this.vehlCd, '') }); //차종코드
				this.setStateApcnSave_({ key: 'carTypeNm', value: convertNvl(this.carTypeNm, '') }); //차종유형
				this.setStateApcnSave_({ key: 'custNm', value: convertNvl(this.custNm, '') }); //판매사
				this.setStateApcnSave_({ key: 'saleRegnNm', value: convertNvl(this.saleRegnNm, '') }); //판매지역
				this.setStateApcnSave_({
					key: 'erpSaleDd',
					value: convertNvl(this.erpSaleDd, '') == '' ? '' : moment(this.erpSaleDd).format('YYYYMMDD')
				}); //HTWO판매일
				this.setStateApcnSave_({ key: 'milg', value: convertNvl(this.milg, '') }); //주행거리
				this.setStateApcnSave_({ key: 'usePrdPo', value: convertNvl(this.usePrdPo, '') }); //보증사용기간
				this.setStateApcnSave_({ key: 'milgPo', value: convertNvl(this.milgPo, '') }); //보증주행거리
				this.setStateApcnSave_({ key: 'flclSpcNm', value: convertNvl(this.flclSpcNm, '') }); //연료전지사양
				this.setStateApcnSave_({
					key: 'oemSaleDd',
					value: convertNvl(this.oemSaleDd, '') == '' ? '' : moment(this.oemSaleDd).format('YYYYMMDD')
				}); //고객판매일
				this.setStateApcnSave_({
					key: 'wrntStrtDd',
					value: convertNvl(this.wrntStrtDd, '') == '' ? '' : moment(this.wrntStrtDd).format('YYYYMMDD')
				});
				this.setStateApcnSave_({
					key: 'wrntEndDd',
					value: convertNvl(this.wrntEndDd, '') == '' ? '' : moment(this.wrntEndDd).format('YYYYMMDD')
				});
				this.setStateApcnSave_({ key: 'licensePlate', value: convertNvl(this.licensePlate, '') }); //차량번호판
				this.setStateApcnSave_({ key: 'carVin', value: convertNvl(this.carVin, '') });
			}
		}
	}
};
</script>

<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: -3px;
}
</style>
